import axiosInstance from '../../api/axios';

const UserService = {
  getAllUsers: async () => {
    try {
      const response = await axiosInstance.get('/admin/users');
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
  createUser: async (userData) => {
    try {
      const response = await axiosInstance.post('/admin/users', userData);
      if (response.data.success) {
        return response.data.message;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
  updateUser: async (id, userData) => {
    try {
      const response = await axiosInstance.put(`/admin/users/${id}`, userData);

      if (response.data.success) {
        return response.data.message;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      const response = await axiosInstance.delete(`/admin/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDevicesWithSessions: async () => {
    try {
      const response = await axiosInstance.get('/admin/devices-with-sessions');
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },

  terminateSessionByDevice: async (deviceIdentifier) => {
    try {
      const response = await axiosInstance.delete('/admin/session/deactivate', {
        data: { device_identifier: deviceIdentifier }
      });
      if (response.data.success) {
        return response.data.message;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  }
};

export default UserService;